import React from "react";
import direction from "../../../service/direction.json";
const WhoiseVOP = () => {
  return (
    <div className="form-group row col-md-12 text-justify">
      <div className="col-md-6">
        <div style={{ width: "18rem;", fontSize: "20px" }}>
          <div className="card-body">
            <h5 className="card-title text-bold" style={{ fontSize: "30px" }}>
              تلفن ثابت ابری چیست؟
            </h5>
            <p className="card-text">
              ارائه خدمات تلفنی دیگر از انحصار مستقیم مخابرات خارج شده و الان
              شرکت های ارائه دهنده اینترنت (ISP) مانند شرکت آسیاتک وارد حوزه
              ارائه خدمات تلفنی شده اند. دیگر برای داشتن خط تلفن ثابت نیازی به
              سیم کشی و ملزومات فیزیکی نیست و میتوانید بر بستر اینترنت (ابری) خط
              تلفن ثابت داشته باشید که قیمتگذاری خط و هزینه مکالمات ارتباط
              مستقیم به مخابرات ندارد و همچنین امکانات منحصر به فردی روی این خط
              تلفن میتوان پیاده سازی کرد.
              <br />
              با توجه به ویژگی ها و امکانات منحصر به فردی که این سرویس دارد ممکن
              است اسم ها و عناوین مختلفی داشته باشد: تلفن ابری، تلفن مجازی، تلفن
              اینترنتی، تلفن گویا، سانترال اینترنتی، تلفن ویپ voip اینترنتی و …
            </p>
          </div>
        </div>
      </div>
      <div className="col-md-6 text-center">
        <img
          src={`${direction.ImgDesign}whats-cloud-phone.jpg`}
          alt="سایه بان"
        />
      </div>
    </div>
  );
};

export default WhoiseVOP;
